module.exports = __webpack_public_path__ + "img/quarterThree.a3b47b4d.png";